import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-blank',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlankComponent { }